function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 13.273c0-5.16 4.173-9.333 9.333-9.333s9.334 4.173 9.334 9.333c0 5.27-5.29 12.428-7.904 15.645-.748.92-2.112.92-2.859 0C12.289 25.701 7 18.543 7 13.273zm6 0a3.334 3.334 0 006.667 0 3.335 3.335 0 00-6.667 0z",
  fill: "#8781bd",
  fillRule: "evenodd"
});

function SvgLocation32Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    width: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMzIiB2aWV3Qm94PSIwIDAgMzIgMzMiIHdpZHRoPSIzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im03IDEzLjI3MzNjMC01LjE2MDAyIDQuMTczMy05LjMzMzM2IDkuMzMzMy05LjMzMzM2czkuMzMzNCA0LjE3MzM0IDkuMzMzNCA5LjMzMzM2YzAgNS4yNjk0LTUuMjg4OSAxMi40Mjc2LTcuOTA0IDE1LjY0NS0uNzQ3My45MTk0LTIuMTExNC45MTk0LTIuODU4NyAwLTIuNjE1MS0zLjIxNzQtNy45MDQtMTAuMzc1Ni03LjkwNC0xNS42NDV6bTYgMGMwIDEuODQgMS40OTMzIDMuMzMzMyAzLjMzMzMgMy4zMzMzczMuMzMzNC0xLjQ5MzMgMy4zMzM0LTMuMzMzMy0xLjQ5MzQtMy4zMzMzNi0zLjMzMzQtMy4zMzMzNi0zLjMzMzMgMS40OTMzNi0zLjMzMzMgMy4zMzMzNnoiIGZpbGw9IiM4NzgxYmQiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgLocation32Px as ReactComponent };